























import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import equipment from './equipment.vue';
import organization from './organization.vue';
import rescueEquipment from './rescueEquipment.vue';
import rescuePerson from './rescuePerson.vue';
import reservePlan from './reservePlan.vue';
import reservePlanDrill from './reservePlanDrill.vue';
@Component({
	name:'emergencyRescue',
	components: {
		equipment,
		organization,
		rescueEquipment,
		rescuePerson,
		reservePlan,
		reservePlanDrill
	}
})
export default class EmergencyRescue extends AbpBase {
	initData:any = {
		currentName: 'organization'
	}
	//切换详情内容
    Switch(name:any){
        this.initData.currentName = name;
    }
    showPage(name:any) {
    	if(this.initData.currentName == name) {
    		return true;
    	}
    	return false;
    }
}
